import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { getExpirationPoints } from '../../../store/componentStores/Account/account.selectors';
import {
  getCurrentResortPhone,
  getResortLocationUrlParam
} from '../../../store/componentStores/CurrentLodge/currentLodge.selectors';
import { getIsLoyaltyPointsExpirationOnProfileEnabled } from '../../../store/componentStores/LodgeConfig/lodgeConfig.selectors';
import { showLoyalty } from '../../../store/reducers';
import { getTermsAndConditionUrl } from '../../../utilities/navigationUtils';
import { GwDatesWrapper } from '../../_internal_date_/gwDatesWrapper';
import { Box, Button, Flex, Text, TextLink } from '../../ui-kit';
import theme from '../../ui-kit/themes/theme';
import { editCopyByReplaceMultipleStrings, editCopyByReplaceString } from '../../utilities/copyFunctions';
import { LOYALTY_IMAGES } from '../assets/images';
import {
  BookNowWhite,
  Icon,
  LoyaltyProfileContainer,
  PointConditionsAndTerms,
  PointsContainer,
  PointsExpirationContainer,
  PointsInnerFlexContainer,
  SpanDot
} from '../assets/styles';
import * as COPY from '../utilities/copy';

const DotItemOnList = ({ mb, loyaltyRedesign2025Active, text }) => {
  return (
    <Flex alignItems="center" flexDirection="row" mb={mb}>
      <SpanDot width={5} height={5} mr={8} />
      <Text
        fontSize={loyaltyRedesign2025Active ? [0, 0, 0, 1] : [0]}
        fontWeight="medium"
        lineHeight={loyaltyRedesign2025Active ? '150%' : [18]}
        color={loyaltyRedesign2025Active ? 'deepForestGreen.100' : 'voyagersColors.100'}>
        {text}
      </Text>
    </Flex>
  );
};

const LoyaltyProfilePoints = ({
  amount,
  iconLink,
  showLoyalty,
  currentResortPhone,
  resortLocationUrlParam,
  expirationPointsObject,
  isLoyaltyPointsExpirationOnProfileEnabled,
  loyaltyRedesign2025Active
}) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.xl})`
  });

  const { nextExpirationDate, expiringMetricValue } = expirationPointsObject;

  const expirationObject = {
    '<POINTS>': expiringMetricValue ?? 0,
    '<DATE>': GwDatesWrapper.format(nextExpirationDate, 'MMM DD, YYYY')
  };

  return (
    <>
      {showLoyalty ? (
        <LoyaltyProfileContainer loyaltyRedesign2025Active={loyaltyRedesign2025Active}>
          {expirationPointsObject && expiringMetricValue !== 0 && isLoyaltyPointsExpirationOnProfileEnabled ? (
            <PointsExpirationContainer>
              <SpanDot />
              <Text
                fontSize={[0, 0, 0, 0, 1]}
                fontWeight="bold"
                color={'voyagersColors.100'}
                lineHeight={[16, 16, 16, 16, 20]}>
                {editCopyByReplaceMultipleStrings(COPY.EXPIRATION_POINTS, expirationObject)}
              </Text>
            </PointsExpirationContainer>
          ) : null}

          <PointsContainer loyaltyRedesign2025Active={loyaltyRedesign2025Active}>
            {loyaltyRedesign2025Active ? (
              <Box textAlign={isMobile ? 'center' : 'left'} mb={[3]}>
                <Text color={'pureWhite.0'} fontSize={[7]} fontWeight="bold" lineHeight={[22, 22, 22, 22, 24]}>
                  {COPY.AVAILABLE_VOYAGERS_POINTS}
                </Text>
              </Box>
            ) : null}
            <PointsInnerFlexContainer loyaltyRedesign2025Active={loyaltyRedesign2025Active}>
              <Box mb={[4, 4, 4, 4, 0]}>
                <Flex flexDirection="column" width="100%">
                  {loyaltyRedesign2025Active ? null : (
                    <Box textAlign="center" mb={[3]}>
                      <Text color={'pureWhite.0'} fontSize={[7]} fontWeight="bold" lineHeight={[22, 22, 22, 22, 24]}>
                        {COPY.AVAILABLE_VOYAGERS_POINTS}
                      </Text>
                    </Box>
                  )}

                  <Flex justifyContent={isMobile ? 'center' : 'start'} alignItems="center" flexDirection="row">
                    <Icon size="32px" src={iconLink} alt="Loyalty" />
                    <Text
                      ml="12px"
                      color={loyaltyRedesign2025Active ? 'voyagersMoonlight' : 'pureWhite.0'}
                      fontSize={[6, 6, 6, 6, 13]}
                      fontWeight={loyaltyRedesign2025Active ? 'heavy' : 'bold'}
                      lineHeight={loyaltyRedesign2025Active ? '112%' : [48]}>
                      {amount}
                    </Text>
                    <Text
                      ml={1}
                      color={loyaltyRedesign2025Active ? 'voyagersMoonlight' : 'pureWhite.0'}
                      fontSize={[4, 4, 4, 4, 5]}
                      fontWeight="heavy"
                      lineHeight={'112%'}>
                      {COPY.POINTS}
                    </Text>
                  </Flex>
                </Flex>
              </Box>
              <Box>
                <BookNowWhite loyaltyRedesign2025Active={loyaltyRedesign2025Active}>
                  <Button
                    fluid={loyaltyRedesign2025Active}
                    variant={loyaltyRedesign2025Active ? 'secondaryLoyalty2025' : 'primary'}
                    as="a"
                    href={`${resortLocationUrlParam}plan`}
                    size={loyaltyRedesign2025Active ? 'desktopLarge2025' : 'medium'}>
                    {COPY.BOOK_NOW}
                  </Button>
                </BookNowWhite>
              </Box>
            </PointsInnerFlexContainer>
          </PointsContainer>
          <PointConditionsAndTerms loyaltyRedesign2025Active={loyaltyRedesign2025Active}>
            <Box>
              <DotItemOnList
                mb={[9, 9, 9, 9, '7px']}
                loyaltyRedesign2025Active={loyaltyRedesign2025Active}
                text={COPY.USE_POINTS_NEXT_BOOKING}
              />
              <DotItemOnList
                mb={[9, 9, 9, 9, '7px']}
                loyaltyRedesign2025Active={loyaltyRedesign2025Active}
                text={COPY.POINTS_ADDED_UPON_COMPLETION}
              />
              <DotItemOnList
                mb={loyaltyRedesign2025Active ? 7 : [7, 7, 7, 7, 9]}
                loyaltyRedesign2025Active={loyaltyRedesign2025Active}
                text={COPY.TEMP_EXPIRATION_NOTICE}
              />
              <Box
                textAlign={isMobile && !loyaltyRedesign2025Active ? 'center' : 'left'}
                mb={['24px', '24px', '24px', '24px', '0px']}>
                <TextLink
                  href={getTermsAndConditionUrl()}
                  target="_blank"
                  underline
                  color={loyaltyRedesign2025Active ? 'deepForestGreen.100' : 'voyagersColors.100'}
                  fontSize={loyaltyRedesign2025Active ? [0] : [1]}
                  fontWeight="bold"
                  lineHeight={loyaltyRedesign2025Active ? '150%' : [18]}>
                  {COPY.SEE_TERMS_AND_CONDITIONS}
                </TextLink>
              </Box>
            </Box>
            <Box textAlign={isMobile ? 'left' : 'right'}>
              <Text
                fontSize={loyaltyRedesign2025Active ? [0] : [9]}
                fontWeight="medium"
                lineHeight={[16]}
                color={loyaltyRedesign2025Active ? 'deepForestGreen.100' : 'voyagersColors.100'}>
                {editCopyByReplaceString(COPY.CLOSE_ACCOUNT, currentResortPhone, '<<phone>>')}
              </Text>
            </Box>
          </PointConditionsAndTerms>
        </LoyaltyProfileContainer>
      ) : null}
    </>
  );
};

LoyaltyProfilePoints.propTypes = {
  amount: PropTypes.number,
  iconLink: PropTypes.string,
  showLoyalty: PropTypes.bool,
  locationPhone: PropTypes.string,
  expirationPointsObject: PropTypes.object
};
LoyaltyProfilePoints.defaultProps = {
  amount: '0',
  iconLink: LOYALTY_IMAGES.ADVENTURE_BUCK_COIN_WHITE,
  showLoyalty: false,
  locationPhone: '',
  expirationPointsObject: {
    nextExpirationDate: '',
    expiringMetricValue: 0
  }
};

const mapStateToProps = state => ({
  showLoyalty: showLoyalty(state),
  currentResortPhone: getCurrentResortPhone(state.currentLodge),
  resortLocationUrlParam: getResortLocationUrlParam(state.currentLodge),
  expirationPointsObject: getExpirationPoints(state.account),
  isLoyaltyPointsExpirationOnProfileEnabled: getIsLoyaltyPointsExpirationOnProfileEnabled(state.lodgeConfig)
});

export default connect(mapStateToProps, null)(LoyaltyProfilePoints);
